<template>
  <span>
    <input type="checkbox" id="toggle-check" @change="check($event)">
    <label for="toggle-check" class="toggle-label">
      <div class="toggle-container">
        <div class="toggle-light-icon icon-toggle">
          <svgicon name="CategoryCubes"></svgicon>
        </div>
        <div class="toggle-dark-icon icon-toggle">
          <svgicon name="CategoryLines"></svgicon>
        </div>
        <div class="toggle-circle"></div>
      </div>
    </label>
  </span>
</template>

<script>
export default {
  name: "BaseToggle",
  methods: {
    check(e) {
      this.$emit(e.target.checked ? 'check' : 'uncheck');
    }
  }
}
</script>

<style scoped lang="scss">

  .toggle-container {
    width: 48px;
    height: 26px;
    background: rgba(0,32,77, .08);
    border-radius: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 5px;
    position: relative;
    transition: background .5s;
    overflow: hidden;
    cursor: pointer;
    .icon-toggle {
      z-index: 3;
      svg {
        fill: #fff;
        width: 9px;
        height: 9px;
      }
    }
    .toggle-dark-icon {
      margin-left: 8px;
      z-index: 3;
      transform: translateX(-4.5px);

      svg {
        fill: rgba(0, 32, 77, 0.5);
        transition: all .3s ease-in-out;
      }
    }
    .toggle-light-icon {
      svg {
        position: relative;
        right: 0px;
        transition: all .3s ease-in-out;
        fill: white;
      }
    }
    .toggle-circle {
      width: 20px;
      height: 20px;
      position: absolute;
      background: rgba(155, 194, 37, 1);
      border-radius: 50%;
      // opacity: .2;
      left: 9%;
      transition: left .5s;
      z-index: 1;
      box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.15);
    }
    svg {
      width: 9px;
      height: 9px;
      margin-left: 4px;
      transform: translateY(-1px);
    }
  }

  #toggle-check {
    display: none;
    &:checked~.toggle-label .toggle-container {
      .toggle-circle {
        left: calc(62% - 5px);
      }
      .toggle-light-icon {
        svg {
          fill: rgba(0, 32, 77, 0.5);
        }
      }
      .toggle-dark-icon {
        svg {
          fill: white;
          /*transform: scale(1) rotate(180deg);*/
          /*right: 0px;*/
        }
      }
    }
  }
</style>
